<template>
    <div v-if="getPermission.settings.view">

        <md-tabs md-sync-route class="load-and-stage-tabs">
          <md-tab id="tab-load" md-label="Loads" to="/gstLoadAndStage/gstLoads"></md-tab>
          <md-tab id="tab-stage" md-label="Stages" to="/gstLoadAndStage/gstStages"></md-tab>
        </md-tabs>
        <router-view/>

    </div>

</template>

<style lang="scss">


  .load-and-bill-tabs {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }
</style>


<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>



